import { getIdentifier } from "../../../../../utils/helpers/getIdentifier";

export const getRequestsCounts = (requests) => {
  const countsByIds = {};
  requests.forEach((request) => (countsByIds[getIdentifier(request)] = request.count));
  return countsByIds;
};
